import React, { useState, useEffect } from "react";
import { fetchFAQs } from "../api";

function AccordionItem({ faq, index, isOpen, onToggle }) {
  return (
    <div
      className={`border-b transition-colors duration-200 ${isOpen ? "border-gold/40" : "border-stone-200"}`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-5 text-left group"
      >
        <span
          className={`font-body text-sm md:text-base transition-colors duration-200 ${isOpen ? "text-stone-900 font-medium" : "text-stone-700"}`}
        >
          <span className="text-gold mr-2">{index}.</span>
          {faq.question}
        </span>
        <span
          className={`ml-4 flex-none w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? "bg-gold rotate-45" : "bg-stone-100 group-hover:bg-stone-200"}`}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isOpen ? "white" : "#78716c"}
            strokeWidth="2.5"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>
      <div
        className="overflow-hidden transition-all duration-400 ease-in-out"
        style={{ maxHeight: isOpen ? "300px" : "0px", opacity: isOpen ? 1 : 0 }}
      >
        <p className="font-body text-stone-500 text-sm leading-relaxed pb-6 pr-12">
          {faq.answer}
        </p>
      </div>
    </div>
  );
}

// Skeleton
function FAQSkeleton() {
  return (
    <div className="border-b border-stone-100 py-5 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-4 bg-stone-100 rounded w-3/4" />
        <div className="w-7 h-7 rounded-full bg-stone-100 flex-shrink-0 ml-4" />
      </div>
    </div>
  );
}

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    fetchFAQs()
      .then((d) => {
        const data = d.data || [];
        setFaqs(data);
        if (data.length > 0) setOpenId(data[0]._id);
      })
      .catch(() => setFaqs([]))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="faq" className="bg-white py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start justify-between mb-10">
          <div>
            <span className="inline-block font-body text-[10px] tracking-[0.25em] uppercase text-[#D29D4E] border border-[#D29D4E] px-3 py-1 rounded-full mb-4">
              FAQ's
            </span>
            <h2
              className="font-display font-normal text-stone-900 leading-tight"
              style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}
            >
              Questions About Franchising?
            </h2>
          </div>
        </div>

        <div className="divide-y divide-stone-100 border-t border-stone-200">
          {loading ? (
            [...Array(5)].map((_, i) => <FAQSkeleton key={i} />)
          ) : faqs.length === 0 ? (
            <p className="font-body text-stone-400 text-sm py-8">
              No FAQs available.
            </p>
          ) : (
            faqs.map((faq, i) => (
              <AccordionItem
                key={faq._id}
                faq={faq}
                index={i + 1}
                isOpen={openId === faq._id}
                onToggle={() => toggle(faq._id)}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
}
